import capitalizeFilter from '../../../filters/capitalize-filter';
import WhiteLabel from '../../../filters/WhiteLabel';

export const getNumTrainingItemsText = (training: { _type: string; stepCount?: number; courseCount?: number }) => {
  const numItems = training._type === 'Course' ? training.stepCount : training.courseCount;
  const item = `${numItems} ${
    training._type === 'Course' ? capitalizeFilter(WhiteLabel.labels.step) : capitalizeFilter(WhiteLabel.labels.course)
  }${numItems || 0 > 1 ? 's' : ''}`;
  return item;
};
